module.exports = __webpack_public_path__ + "media/images/prizes__prizeBg__deco-53a153c2c1aaa21398f758ac1e34bb36.png";